import React,{ useState, useEffect } from 'react';

import {
    Alert
} from 'antd';

import {
    QuestionOutlined
} from '@ant-design/icons';

import MacImage1 from '../../images/modem-swap/mac-address-location-fig1.png';
import MacImage2 from '../../images/modem-swap/mac-address-location-fig2.png';
import ModemSyncImage1 from '../../images/modem-swap/modem-sync-fig1.png';
import ModemSyncImage2 from '../../images/modem-swap/modem-sync-fig2.png';
import ModemSyncImage3 from '../../images/modem-swap/modem-sync-fig3.png';

const siteDomain = headerVars.siteDomain;

function ModemUpgradeTroubleshooting() {
    return (
        <div id="modem-setup-component" className="modem-setup-component modem-upgrade-component">
            <h4>Modem Upgrade troubleshooting</h4>
            <p>If you encounter any difficulty throughout the modem swap process, please visit <a href="/contact" target="_blank">https://www.start.ca/contact</a> for additional support options.  For additional service setup guidelines (Internet, voice, and TV), please visit <a href="/support/hardware-setup" >https://start.ca/support/hardware-setup</a>.</p>
            <p>If there are physical and/or special assistance requirements – and you’re unable to coordinate assistance before the automated network configuration date and time (as specified on the email that we recently sent), please contact us to request a 1-2 week extension. </p>
            <p>If you were renting the old modem, please do not return it to us.  Recycling your old modem, at any local e-waste depot, will help keep our communities green.</p>


            <div className='modem-swap-walkthrough-container '>
                <div className='modem-swap-walkthrough-item'>
                    <div className='modem-swap-walkthrough-item-desc modem-troubleshhoting'>
                        <p><b>Illustration 1a (Hitron CODA56):</b><br/>Full synch status of the modem, highlighting (with a red box) the lights that should be green, prior to reconnecting your router.</p>
                    </div>
                    <div className='modem-swap-step-description'>
                        <img src={ ModemSyncImage1 } />
                    </div>
                </div>
                <div className='modem-swap-walkthrough-item'>
                    <div className='modem-swap-walkthrough-item-desc modem-troubleshhoting'>
                        <p><b>Illustration 1b (Sercomm DM1000):</b><br/>Full synch status of the modem, highlighting (with a red box) the lights that should be green, prior to reconnecting your router.</p>
                    </div>
                    <div className='modem-swap-step-description'>
                        <img src={ ModemSyncImage2 } />
                    </div>
                </div>
            </div>

            <div className='troubleshooting-illustration-item' style={{ marginBottom:"3rem" }}>
                <img src={ ModemSyncImage3 } />
            </div>

            <Alert 
                message="If you are still not seeing a connection after 1 hour, please find a paper clip or pin and insert it in the reset button area and hold until all the lights blink on the modem.  The modem will take up to 10 minutes to come online, then connect to your router and you should be good to go!" 
                type="info" 
                showIcon />

            <div className='modem-swap-walkthrough-container ' style={{ marginTop: '5rem' }}>
                <div className='modem-swap-walkthrough-item'>
                    <div className='modem-swap-walkthrough-item-desc modem-troubleshhoting'>
                        <p><b>Illustration 2a (Hitron CODA56):</b><br/>MAC address location (back of the modem).</p>
                    </div>
                    <div className='modem-swap-step-description'>
                        <img src={ MacImage1 } />
                    </div>
                </div>
                <div className='modem-swap-walkthrough-item'>
                    <div className='modem-swap-walkthrough-item-desc modem-troubleshhoting'>
                        <p><b>Illustration 2b (Sercomm DM1000):</b><br/>MAC address location (bottom of the modem) </p>
                    </div>
                    <div className='modem-swap-step-description'>
                        <img src={ MacImage2 } />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModemUpgradeTroubleshooting